/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSummaryCount {
    getFixupPrototypeFunction() { return TagPostureSummaryCount.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSummaryCount>): TagPostureSummaryCount {
        let obj = Object.assign(new TagPostureSummaryCount(), model);
        TagPostureSummaryCount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSummaryCount>): TagPostureSummaryCount {
        if (!model) return null;
        return TagPostureSummaryCount.newInstance(<TagPostureSummaryCount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSummaryCount) {
        if (!obj) return;

        models.TagPostureSummaryCount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSummaryCount): boolean {
        Object.setPrototypeOf(obj, TagPostureSummaryCount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.valid_count === undefined) {
            this.valid_count = 0;
        }
        if (this.invalid_count === undefined) {
            this.invalid_count = 0;
        }
        if (this.missing_keys_count === undefined) {
            this.missing_keys_count = 0;
        }
        if (this.auto_suggested_count === undefined) {
            this.auto_suggested_count = 0;
        }
    }

    /**
     * Number of valid
     */
    valid_count: number;

    /**
     * Number of invalid
     */
    invalid_count: number;

    /**
     * Number of missing
     */
    missing_keys_count: number;

    /**
     * Number of suggestions
     */
    auto_suggested_count: number;

}
